// components/Filter.js
import React from 'react';
import '../styles/filter.css';

function Filter({ filters, setFilters }) {
  const handleChange = (e) => {
    setFilters({
      ...filters,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="filter-container">
      <select name="category" value={filters.category} onChange={handleChange}>
        <option value="">All Categories</option>
        <option value="Electronics">Electronics</option>
        <option value="Wearables">Wearables</option>
      </select>

      <select name="price" value={filters.price} onChange={handleChange}>
        <option value="">All Prices</option>
        <option value="0-100">$0 - $100</option>
        <option value="100-200">$100 - $200</option>
      </select>

      <select name="rating" value={filters.rating} onChange={handleChange}>
        <option value="">All Ratings</option>
        <option value="4">4 stars & above</option>
        <option value="4.5">4.5 stars & above</option>
      </select>
    </div>
  );
}

export default Filter;
